export interface SwipeMeasurement {
  deltaX: number;
  deltaY: number;
  durationMs: number;
  viewportWidth: number;
  horizontalLocked: boolean;
}

export function isPageTurnSwipe({
  deltaX,
  deltaY,
  durationMs,
  viewportWidth,
  horizontalLocked
}: SwipeMeasurement): boolean {
  if (!horizontalLocked || Math.abs(deltaX) <= Math.abs(deltaY) * 1.12) return false;
  const distanceThreshold = Math.min(96, Math.max(54, viewportWidth * 0.08));
  const deliberateDrag = Math.abs(deltaX) >= distanceThreshold;
  const quickFlick = Math.abs(deltaX) >= 28 && Math.abs(deltaX) / Math.max(durationMs, 1) >= 0.45;
  return deliberateDrag || quickFlick;
}
